module.exports = __webpack_public_path__ + "static/media/inbox.9cb44a9f.png";